import { environment } from '../../environments/environment';

export class ApiRoutes {
  public static APP_NAME: string = 'Download Area';
  public static MAIN_BASE_URL: string = environment.apiUrl;
  private static _AUTH_API_BASE_URL: string = localStorage.getItem('AUTH_API_BASE_URL') || '';
  private static _featuresModuleBaseRoutes: Record<string, string> = JSON.parse(
    localStorage.getItem('FEATURE_ROUTES') || '{}'
  );

  public static set AUTH_API_BASE_URL(value: string) {
    // this._AUTH_API_BASE_URL = value;
    localStorage.setItem('AUTH_API_BASE_URL', value); // persist in localStorage
  }

  public static get AUTH_API_BASE_URL(): string {
    return localStorage.getItem('AUTH_API_BASE_URL') || '';
  }

  public static get featuresModuleBaseRoutes(): Record<string, string> {
    return JSON.parse(localStorage.getItem('FEATURE_ROUTES') || '{}');
  }

  public static set featuresModuleBaseRoutes(routes: Record<string, string>) {
    // this._featuresModuleBaseRoutes = routes;
    localStorage.setItem('FEATURE_ROUTES', JSON.stringify(routes)); // persist in localStorage
  }

  public static get URLS() {
    return {
      MAIN_LOGIN: this.MAIN_BASE_URL + 'api/Login/UserLogin',
      /* For Auth User */
      AUTH_LOGIN: this.MAIN_BASE_URL + 'api/Login/UserLoginWithPwd',
      SSO_LOGIN: this.MAIN_BASE_URL + 'api/Login/SSOLogin',
      LOGOUT: this.MAIN_BASE_URL + 'api/UserManagement/LogOut',
      DOCUMENT_TYPE_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetDocumentType',
      MARKET_SEGEMENT_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetMarketSegment',
      PRODUCT_LINE_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetProductLine',
      LANGUAGE_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetLanguage',
      DASHBOARD_DOCUMENT_LIST: this.MAIN_BASE_URL + 'api/Dashboard/DocumentList',
      CHANGE_PASSWORD: this.MAIN_BASE_URL + 'api/UserManagement/ChangePassword',
      INTERESTED_IN_DOCUMENT: this.MAIN_BASE_URL + 'api/UserManagement/EditInterestedDocuments',

      /*Role API */
      GET_ROLE_LIST: this.MAIN_BASE_URL + 'api/RoleMaster/RoleList',
      GET_ROLE_STATUS: this.MAIN_BASE_URL + 'api/RoleMaster/ActiveInactiveRole',
      ADD_UPDATE_ROLE: this.MAIN_BASE_URL + 'api/RoleMaster/InsertUpdateRole',
      GET_ROLE_PERMISSION_LIST: this.MAIN_BASE_URL + 'api/RoleMaster/ModulePermissionList',

      // Entity API
      GET_ENTITY_LIST: this.MAIN_BASE_URL + 'api/Entity/EntityList',
      GET_ENTITY_STATUS: this.MAIN_BASE_URL + 'api/Entity/UpdateEntityStatus',
      ADD_UPDATE_ENTITY: this.MAIN_BASE_URL + 'api/Entity/AddUpdateEntity',

      // DROPDOWN API
      GET_ENTITY_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetEntity',
      GET_PARENT_ENTITY_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetParentEntityList',
      GET_ACCESS_LEVEL_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetAccessLevelList',
      GET_MARKET_SEGMENT_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetMarketSegment',
        // below user market segement was added as in user page deactivated data was not showing 25/09/2026
      USER_MARKET_SEGEMENT_DATA: this.MAIN_BASE_URL + 'api/Dropdown/MarketSegmentDropdown',
      // 
      GET_COUNTRY_MASTER_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetCountryMaster',
      GET_USER_LOGIN_TYPE_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetUserLoginType',
      GET_USER_LOGIN_WITH_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetUserLoginWith',
      GET_ROLE_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetRoleList',
      GET_USER_TYPE_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetUserType',
      GET_HARDWARE_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetHardware',
      GET_MACHINE_APPLICATION_DATA: this.MAIN_BASE_URL + 'api/DropDown/GetMachineApplication',
      GET_PRODUCT_APPLICATION: this.MAIN_BASE_URL + 'api/DropDown/GetProductApplication',

      // MENU DATA
      GET_ACCESS_PAGE_DATA: this.MAIN_BASE_URL + 'api/UserManagement/UserAccessPage',

      // USER API
      GET_USER_LIST: this.MAIN_BASE_URL + 'api/UserManagement/AllUserList',
      GET_USER_STATUS: this.MAIN_BASE_URL + 'api/UserManagement/ActiveInactiveUser',
      ADD_UPDATE_USER: this.MAIN_BASE_URL + 'api/UserManagement/InsertUpdateUser',

      // Segment API
      GET_SEGMENT_LIST: this.MAIN_BASE_URL + 'api/MarketSegment/MarketSegmentList',
      GET_SEGMENT_STATUS: this.MAIN_BASE_URL + 'api/MarketSegment/ActiveInactiveMarketSegment',
      ADD_UPDATE_SEGMENT: this.MAIN_BASE_URL + 'api/MarketMachineSegment/InsertUpdateSegment',
      GET_APPLICATION_LIST: this.MAIN_BASE_URL + 'api/MarketMachineSegment/GetApplication',
      UPDATE_APPLICATION: this.MAIN_BASE_URL + 'api/MarketMachineSegment/InsertMarketMachineSegment',

      // Product API
      GET_PRODUCT_LIST: this.MAIN_BASE_URL + 'api/ProductSegment/ProductSegmentList',
      GET_PRODUCT_STATUS: this.MAIN_BASE_URL + 'api/ProductSegment/ActiveInactiveProductSegment',
      ADD_UPDATE_PRODUCT: this.MAIN_BASE_URL + 'api/ProductSegment/UpdateProductSegment',

      // Document API
      GET_DOCUMENT_LIST: this.MAIN_BASE_URL + 'api/DocumentSegment/DocumentSegmentList',
      GET_DOCUMENT_STATUS: this.MAIN_BASE_URL + 'api/DocumentSegment/ActiveInactiveDocumentSegment',
      ADD_UPDATE_DOCUMENT: this.MAIN_BASE_URL + 'api/DocumentSegment/UpdateDocumentSegment',

      // Hardware API
      GET_HARDWARE_LIST: this.MAIN_BASE_URL + 'api/Hardware/HardwareList',
      GET_HARDWARE_STATUS: this.MAIN_BASE_URL + 'api/Hardware/ActiveInactiveHardware',
      ADD_UPDATE_HARDWARE: this.MAIN_BASE_URL + 'api/Hardware/UpdateHardware',

      //Language API
      GET_LANGUAGE_LIST: this.MAIN_BASE_URL + '/api/DropDown/GetLanguageList',
      EDIT_LANGUAGE: this.MAIN_BASE_URL + '/api/UserManagement/EditLanguage',

      //Login API
      FORGOT_PASSWORD: this.MAIN_BASE_URL + 'api/Login/ForgotPassword',
      SAVE_FORGOT_PASSWORD: this.MAIN_BASE_URL + 'api/Login/ResetPassword',
    };
  }
}
